import { Colors } from '../../../theme';

export const buttonNavTheme = {
  white: {
    base: {
      backgroundColor: Colors.grey000,
      borderColor: Colors.transparent,
      color: Colors.grey700,
    },
    disabled: {},
    hover: {
      color: Colors.blue500,
    },
    focus: {
      borderColor: Colors.blue500,
      color: Colors.blue500,
      outlineColor: Colors.blue500,
    },
    selected: {
      backgroundColor: Colors.white,
      borderColor: Colors.grey200,
      color: Colors.blue500,
    },
  },
};
